import React from "react";
import { sxProps, sxPropTypes } from "../props/sx";
import { Col, Row } from "../Grid";
import Paragraph from "../Paragraph";
import pureProps from "../utils/pureProps";

const AvailableOnOsBody = ({ ...props }) => {
	return (
		<Row className="available-on-os__body">
			<Col sm={12} {...props} />
		</Row>
	);
};

AvailableOnOsBody.propTypes = {
	...Col.propTypes,
};

const Item = ({ sx = { ...sxProps }, ...props }) => {
	return (
		<Paragraph
			sx={{ fontSize: "l", fontColor: "white", textAlign: "center", ...pureProps(sx) }}
			{...props}
		/>
	);
};

Item.propTypes = {
	sx: sxPropTypes,
	...Paragraph.propTypes,
};

AvailableOnOsBody.Item = Item;

export default AvailableOnOsBody;
